import { unifiedInboxSupportConversationKey } from "@circle-react/lib/queries/unifiedInboxSupportConversations";
import { useQuery } from "react-query";

import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

interface ApiResponse {
  unread_count: number;
}

export const SUPPORT_UNREAD_CONVERSATIONS_COUNT_QUERY_KEY =
  unifiedInboxSupportConversationKey.unreadCount();

export const useSupportUnreadConversationsCount = () => {
  const fetchUnreadConversationsCount = (): Promise<ApiResponse> =>
    reactQueryGet(internalApi.unifiedInboxSupport.unreadConversations());

  return useQuery({
    queryKey: SUPPORT_UNREAD_CONVERSATIONS_COUNT_QUERY_KEY,
    queryFn: fetchUnreadConversationsCount,
    select: response => response.unread_count,
  });
};
